// Web shim for @react-native-community/checkbox
import React from 'react';
import { View, Pressable, StyleSheet } from 'react-native';

const CheckBox = React.forwardRef((props: any, ref: any) => {
  const {
    value = false,
    disabled = false,
    onValueChange,
    style,
    onFillColor = '#007AFF',
    onCheckColor = '#FFFFFF',
    tintColor = '#AAAAAA',
    onTintColor = '#007AFF',
    tintColors,
    ...otherProps
  } = props;

  const handlePress = () => {
    if (!disabled && onValueChange) {
      onValueChange(!value);
    }
  };

  // 确定边框颜色
  const getBorderColor = () => {
    if (tintColors && typeof tintColors === 'object') {
      return value ? (tintColors.true || onTintColor) : (tintColors.false || tintColor);
    }
    return value ? onTintColor : tintColor;
  };

  const borderColor = getBorderColor();
  const checkmarkColor = onCheckColor;
  const fillColor = onFillColor;

  // 从 style 中提取尺寸
  const getSize = () => {
    let width = 20;
    let height = 20;
    
    if (style) {
      const styles = Array.isArray(style) ? style : [style];
      for (const s of styles) {
        if (s && typeof s === 'object') {
          if (s.width) width = s.width;
          if (s.height) height = s.height;
        }
      }
    }
    
    return { width, height };
  };

  const size = getSize();

  return (
    <Pressable
      ref={ref}
      onPress={handlePress}
      disabled={disabled}
      style={[
        styles.container,
        style,
        { opacity: disabled ? 0.5 : 1 },
      ]}
      {...otherProps}
    >
      <View
        style={[
          styles.checkbox,
          {
            width: size.width,
            height: size.height,
            backgroundColor: value ? fillColor : 'transparent',
            borderColor: borderColor,
            borderWidth: 2,
            borderRadius: Math.min(size.width, size.height) * 0.2,
          },
        ]}
      >
        {value && (
          <View style={styles.checkmarkContainer}>
            <View
              style={[
                styles.checkmark,
                {
                  borderColor: checkmarkColor,
                  width: size.width * 0.4,
                  height: size.height * 0.5,
                },
              ]}
            />
          </View>
        )}
      </View>
    </Pressable>
  );
});

CheckBox.displayName = 'CheckBox';

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  checkbox: {
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
  },
  checkmarkContainer: {
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
  },
  checkmark: {
    borderBottomWidth: 2,
    borderRightWidth: 2,
    transform: [{ rotate: '45deg' }],
    marginTop: -2,
  },
});

export default CheckBox;
